<div class="update-record-dialog">
  <section class="record-summary" aria-label="Remarks context">
    <div class="record-summary__icon" aria-hidden="true">
      <i class="pi pi-comment"></i>
    </div>

    <div class="record-summary__copy">
      <span class="record-summary__eyebrow">Remarks</span>
      <h2>{{ dialogData?.descriptions?.length || 0 }} note{{ dialogData?.descriptions?.length !== 1 ? 's' : '' }}</h2>
    </div>
  </section>

  <section
    class="form-section"
    *ngFor="let issue of dialogData.descriptions"
  >
    <ng-container *ngIf="issue.remarks !== null && issue.remarks !== undefined">
      <div class="form-section__header">
        <h3>{{ issue.description }}</h3>
      </div>

      <div class="form-field">
        <textarea
          pInputTextarea
          [(ngModel)]="issue.remarks"
          [autoResize]="true"
          rows="3"
          class="w-full"
          (blur)="updateRemarks(issue)"
        ></textarea>
      </div>
    </ng-container>
  </section>
</div>
